var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLock = function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-testid": "LockIcon",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.333 8.333V6.667a3.333 3.333 0 0 0-6.666 0v1.666h-.834A.833.833 0 0 0 5 9.167v6.666c0 .46.373.834.833.834h8.334c.46 0 .833-.373.833-.834V9.167a.833.833 0 0 0-.833-.834zM10 12.5a.833.833 0 1 0 0 1.667.833.833 0 0 0 0-1.667m2.5-4.167h-5V6.667a1.667 1.667 0 1 1 3.333 0v1.666z",
    clipRule: "evenodd"
  })));
};
export default SvgLock;